<template>
    <div>
        <multiselect
            ref="multiselect"
            class="orders-products-list select-filter-product form-control d-block"
            :class="{ 'non-full-width': nonFullWidth }"
            v-model="newSelectedOptions"
            :options="options"
            track-by="_id"
            label="name"
            :show-labels="false"
            :preselect-first="false"
            :allow-empty="true"
            :multiple="true"
            :closeOnSelect="false"
            placeholder="Select Product"
            @search-change="onChangeProductSearch"
            @input="onSelectProducts"
        >
            <template slot="selection" slot-scope="{ values, isOpen }">
                <span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                >
                    {{ values.length }} Product Selected
                </span>
            </template>
            <span slot="noResult">
                No products found
            </span>
            <template slot="option" slot-scope="{ option }">
                <div class="custom-option" v-tooltip="{ content: option.name }">
                    <input
                        type="checkbox"
                        :value="option"
                        v-model="newSelectedOptions"
                        class="custom-checkbox"
                        @change="onSelectProductsCheckbox"

                    />
                    <span class="option-name">{{ option.name }}</span>
                </div>
            </template>
            <template slot="singleLabel" slot-scope="{ option }">
                {{ option }}
            </template>
            <template slot="beforeList">
                <div class="p-4" v-if="isFetching">
                    <div class="is-loading dark"></div>
                </div>
                <label class="d-block custom-select-all" v-else>
                    <input
                        type="checkbox"
                        class="custom-checkbox"
                        v-model="selectAll"
                    />
                        <!-- :checked="selectAllText === 'Clear All'" -->
                        <!-- @click.stop="toggleSelectAll" -->
                    <!-- <span @click="toggleSelectAll">{{ $t(selectAllText) }}</span> -->
                    <span>{{ $t(selectAllLabel) }}</span>
                </label>
            </template>
            <template slot="afterList">
                <div
                    class="select-loadmore"
                    @click="fetch(false)"
                    v-if="hasNextPage && !isFetching"
                >
                    {{ $t('Load More') }}
                </div>
            </template>
        </multiselect>
    </div>
    </template>

<script>
import Multiselect from 'vue-multiselect';
import productsApi from '@/api/products';
import { delay } from '@/lib/helper';

export default {
	name: 'ProductMultiselect',
	components: {
		Multiselect,
	},
	props: {
		nonFullWidth: {
			type: Boolean,
			required: false,
		},
		selectedProducts: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			newSelectedOptions: [...this.selectedProducts],
			selectAllText: 'Select All',
			options: [],
			page: 1,
			limit: 20,
			keyword: '',
			isFetching: false,
			hasNextPage: false,
			keepOpen: false,
		};
	},
	computed: {
		filteredOptions() {
			const keyword = this.keyword.toLowerCase();
			return this.options.filter(option => option.name.toLowerCase().includes(keyword));
		},
		selectAll: {
			get() {
				return this.newSelectedOptions.length === this.filteredOptions.length;
			},
			set(value) {
				if (value) {
					const filteredOptions = [...this.filteredOptions];
					this.newSelectedOptions = filteredOptions;
				} else {
					this.newSelectedOptions = [];
				}
				this.$emit('input', this.newSelectedOptions);
			},
		},
		selectAllLabel() {
			return this.selectAll ? 'Clear All' : 'Select All';
		},
	},
	methods: {
		toggleSelectAll() {
			if (this.selectAllText === 'Select All') {
				const filteredOptions = [...this.filteredOptions];
				this.newSelectedOptions = filteredOptions;
				this.selectAllText = 'Clear All';
			} else {
				this.newSelectedOptions = [];
				this.selectAllText = 'Select All';
			}
			this.$refs.multiselect.deactivate();
			// Force component update to refresh "selection" slot
			this.$forceUpdate();
			this.$emit('input', this.newSelectedOptions);
			this.keepOpen = true;
		},
		onChangeProductSearch(keyword) {
			delay(() => {
				this.keyword = keyword;
				this.fetch(true);
			}, 500);
		},
		onSelectProducts(products) {
			this.$emit('input', products);
		},
		onSelectProductsCheckbox() {
			this.$emit('input', this.newSelectedOptions);
		},
		createProductFromOption(product) {
			return {
				_id: product?._id?.$oid,
				name: product?.name,
				type: product?.type,
			};
		},
		fetch(reset = false) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.options = [];
			}
			const keyword = this.keyword.trim();
			const params = {
				page: this.page,
				limit: this.limit,
				sort_by: 'name',
				sort: 'asc',
			};
			if (keyword !== '') {
				params.keyword = keyword;
			}
			if (this.getSlug) {
				params.get_slug = this.getSlug;
			}
			const callback = (response) => {
				const products = response.data && response.data.products
					? response.data.products : response.data;
				this.hasNextPage = products.length === this.limit;
				this.appendOptions(products);
				this.page++;
				this.isFetching = false;
			};
			const errorCallback = () => {
				this.isFetching = false;
			};
			productsApi.getProducts(params, callback, errorCallback);
		},
		appendOptions(options) {
			for (let index = 0; index < options.length; index++) {
				const option = options[index];
				this.options.push(option);
			}
		},
	},
	watch: {
		selectedProducts(newSelectedOptions) {
			this.newSelectedOptions = [...newSelectedOptions];
		},
	},
	created() {
		this.fetch();
	},
};
</script>

    <style lang="scss" scoped>
    .select-filter-product {
        &.non-full-width {
            width: 350px;
        }
    }
    .custom-option {
        display: flex;
        align-items: center;
    }
    .custom-checkbox {
        margin-right: 10px;
    }
    .custom-select-all {
        padding: 10px;
        border-bottom: 1px solid #ccc;
        background-color: #f8fbff;
        cursor: pointer;
        &:hover {
            background-color: #f5f5f5;
        }
    }
    .option-name {
        flex-grow: 1;
        max-width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-left: 8px;
    }
    </style>
